import { FC, PropsWithChildren } from 'react'
import { ReactComponent as InfoIcon } from '../../assets/images/info-gray.svg'
import { IntegrationServiceId } from '../../common/integrations'

interface IntegrationDisclaimerProps {
  serviceId: IntegrationServiceId
}

const Disclaimer: FC<PropsWithChildren> = ({ children }) => (
  <div className='py-2 px-3 border border-1 zocks-border-color-gray-300 zocks-border-0.5 zocks-bg-color-gray-100 opacity-75 zocks-text-gray-700'>
    {children}
  </div>
)

const ZoomIntegrationDisclaimer: FC<IntegrationDisclaimerProps> = () => (
  <Disclaimer>
    <div className='d-flex gap-2 justify-content-start align-items-center'>
      <InfoIcon className='flex-shrink-0' />
      Zocks connects to the Zoom account you're signed into in your browser. Check your Zoom account first.
    </div>
  </Disclaimer>
)

const INTEGRATION_SERVICE_ID_COMPONENT_MAP: Partial<{ [key in IntegrationServiceId]: FC<IntegrationDisclaimerProps> }> = {
  [IntegrationServiceId.ZOOM]: ZoomIntegrationDisclaimer,
}

const DefaultIntegrationDisclaimer: FC<IntegrationDisclaimerProps> = () => null

export const IntegrationDisclaimer: FC<IntegrationDisclaimerProps> = (props) => {
  const IntegrationDisclaimerComponent = INTEGRATION_SERVICE_ID_COMPONENT_MAP[props.serviceId] ?? DefaultIntegrationDisclaimer
  return <IntegrationDisclaimerComponent {...props} />
}
